<template>
    <!-- 简报详情 -->
    <div class="news-detail-container">
        <div class="news-content">
            <div class="header">{{ data.title }}</div>
            <ul class="creator-publish-time">
                <li>发布人：{{ data.publishUserName || '-' }}</li>
                <li>发布时间：{{ data.publishTime || '-' }}</li>
                <li>浏览次数：{{ data.viewNum|| 0 }}</li>
                <li>点赞数：{{ data.likeNum || 0 }}</li>
                <li v-if="isFromIdx" class="like-box" @click="changeLike">
                    <i :class="['iconfont', data.isLike ? 'icon-a-tuijianxiao' : 'icon-a-dianzan1x']"></i>点赞
                </li>
            </ul>
            <ul class="keyword-list" v-if="data.tagList?.length">
                <li>关键词：</li>
                <li class="label" v-for="(item, index) in data.tagList" :key="index">{{ item }}</li>
            </ul>
            <div class="content">
                <EditorView
                    v-if="!isFromIdx"
                    :content="data.content"
                    :file-list="data.materialVOList"
                    :is-download="false"
                    :isShowSize="true"
                />
                <FileView
                    v-else-if="data.materialVOList?.length > 0"
                    :file-data="data.materialVOList[0]"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import EditorView from './part/editor-view.vue';
import FileView from './part/file-view.vue';
import {reactive, onMounted, computed, ref, nextTick} from 'vue';
import {useStore} from 'vuex';
import {useRoute} from 'vue-router';
import _ from 'lodash';

const store = useStore();
const route = useRoute();

const id = route.query.id;
const isFromIdx = route.query.type === 'idx';

const data = reactive({
    title: '', // 标题名称
    content: '', // 手动编辑内容
    publishTime: '', // 发布时间
    materialVOList: [],
    viewNum: 0,
    publishUserName: '',
    likeNum: 0,
    isLike: false,
    tagList: []
});

const getStrainNoticeDetailFn = () => {
    if (!id) {
        return false;
    }
    G_transmit('getBulletinInfo', {
        name: 'getBulletinInfo',
        queries: {
            id
        }
    }).then(res => {
        let result = res.data || {};
        Object.assign(data, result);
    });
};

/**
 * 取面包屑上广场的名字
 */
const courseType = computed(() => {
    return route.query.courseType || 2;
});

const typeOptions = ref({
    1: {
        label: '区级研修课程',
        moduleKey: 'train:districtTrain:courseSquare',
        courseType: 1,
        title: '', // 暂无, 名字待扩展
        url: '/idx/districtCourse/square'
    },
    2: {
        label: '校本课程',
        moduleKey: 'train:schoolTrain:courseSquare',
        courseType: 2,
        title: '研修简报',
        url: '/idx/schoolCourse/square'
    }
});

const menuList = computed(() => {
    let list = store.getters['user/userMenus'] || [];
    let temp = _.flatMap(list, item => {
        return _.concat(item.sub_navs || [], item);
    });
    return temp;
});

const curCourseTypeObj = computed(() => {
    menuList.value.forEach(item => {
        if (item?.moduleKey === typeOptions.value[courseType.value].moduleKey) {
            typeOptions.value[courseType.value].label = item.name || item.title;
        }
    });
    return courseType.value ? typeOptions.value[courseType.value] : {};
});

const setBreadCrumb = () => {
    store.dispatch('setBreadCrumb', [
        {
            name: curCourseTypeObj.value?.label,
            route: curCourseTypeObj.value.url
        },
        {
            name: curCourseTypeObj.value.title
        }
    ]);
};

function fetchIsLike() {
    if (!id) return false;
    G_transmit('isLikeBulletin', {
        queries: {
            bulletinId: id
        }
    }).then(res => {
        data.isLike = res.data;
    });
}

function changeLike() {
    if (!id) return false;
    G_transmit('changeLikeBulletin', {
        data: {
            bulletinId: id,
            likeType: data.isLike ? 0 : 1
        }
    }).then(res => {
        data.isLike = !data.isLike;
        data.likeNum += data.isLike ? 1 : -1;
    });
}

onMounted(async () => {
    nextTick(() => {
        setTimeout(() => { setBreadCrumb() }, 500)
    })
    getStrainNoticeDetailFn();
    fetchIsLike();
});
</script>

<style lang="scss" scoped>
.news-detail-container {
    width: 100%;
    .breadcrumb {
        font-size: 14px;
        margin-bottom: 23px;
        .link {
            color: var(--srt-breadcrumb-text-color);
            &:hover {
                color: var(--srt-breadcrumb-hover-text-color);
            }
        }
        .separator {
            margin: 0 6px;
            color: var(--srt-color-gray);
        }
        .text {
            color: var(--srt-breadcrumb-disabled-text-color);
        }
    }
    .news-content {
        background: var(--srt-color-white);
        border-radius: 4px;
        padding: 50px;
        .header {
            font-size: 28px;
            color: var(--srt-main-text-color);
            line-height: 37px;
            font-weight: bold;
            white-space: pre-wrap;
        }
        .creator-publish-time {
            display: flex;
            font-size: 14px;
            color: var(--srt-color-gray);
            margin-top: 10px;
            > li {
                margin-right: 40px;
            }
            .like-box {
                margin-left: auto;
                margin-right: 0;
                cursor: pointer;
                .iconfont {
                    margin-right: 4px;
                }
                .icon-a-tuijianxiao {
                    color: #FFD44D;
                }
            }
        }
        .content {
            border-top: 1px solid #e0e2e4;
            padding-top: 30px;
            margin-top: 30px;
        }
        .keyword-list {
            display: flex;
            font-size: 14px;
            color: var(--srt-color-gray);
            margin-top: 10px;
            .label {
                height: 20px;
                line-height: 20px;
                background: #EFF0F2;
                border-radius: 4px;
                font-size: 12px;
                color: #47698C;
                padding: 0 6px;
                margin-right: 8px;
            }
        }
    }
}
</style>
